/*import { createStore } from 'redux';
const reducers = require('reducers/index');
const store = createStore(reducers);

module.exports = {
    store
}
*/

// @vendor
import reduxCatch from 'redux-catch';
import { applyMiddleware, compose, createStore } from 'redux';
const ReduxThunk = require('redux-thunk').default;
//import createSagaMiddleware from 'redux-saga';
//import sagas from 'sagas/sagas';
const reducers = require('reducers/index');
const {
    syncHistoryWithStore,
    routerMiddleware,
} = require('react-router-redux');
const { browserHistory } = require('react-router-dom');
//const { middlewaresErrorsHandler } = require('middlewares/middlewaresErrorsHandler');
//import { actionTagging, actionTaggingLink } from '../middlewares/actionTagging';
//const voiceReader = require('../middlewares/voiceReader');
//const sagaMiddleware = createSagaMiddleware();

// @constants
//const { LOCAL_ENVIRONMENT, PRODUCTION_ENVIRONMENT, OCULTO_ENVIRONMENT } = require('constants/index');

const middlewares = [
    //reduxCatch(middlewaresErrorsHandler),
    //voiceReader,
    ReduxThunk,
    //sagaMiddleware,
    //actionTagging,
    //actionTaggingLink,
    //routerMiddleware(browserHistory)
];

let enhancers;
/*if (__ENVIRONMENT__ === PRODUCTION_ENVIRONMENT || __ENVIRONMENT__ === OCULTO_ENVIRONMENT){
    enhancers = applyMiddleware.apply(null, middlewares);
} else {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    enhancers = composeEnhancers(
        applyMiddleware.apply(null, middlewares)
    );
}*/

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
enhancers = composeEnhancers(applyMiddleware.apply(null, middlewares));

const store = createStore(reducers, enhancers);

// Running sagas
/*for (let saga of sagas) {
    sagaMiddleware.run(saga)
}*/

//const history = syncHistoryWithStore(browserHistory, store);

// For DEVELOPMENT we want to avoid a continous logout
/*if (__ENVIRONMENT__ === LOCAL_ENVIRONMENT){
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
          const nextReducer = require('../reducers');
          store.replaceReducer(nextReducer);
        });
    }
}*/

module.exports = {
    store,
    history,
};
